import {
  User as BufUser,
  CreateUserResponse,
  GetUserResponse,
  UpdateUserResponse,
} from '@buf/upcyclers_gateway.bufbuild_es/user/v1/user_pb';

import { handleAPIError, InternalError } from '@lib/errors';
import { fetchWrapper } from '@lib/network/fetch-wrapper';
import { handleLog } from '@lib/logging/utils';
import { APIRoutes } from '@lib/routes';

import { User } from './definitions';

export const UserService = {
  getUserById: async (userId: string): Promise<User> => {
    const response = await fetchWrapper(`${APIRoutes.users}/${userId}`, {
      method: 'GET',
    });

    const data = await response.json();

    const errorMessage = 'UserService.getUserById error';
    if (!response.ok) {
      handleLog('error', {
        message: errorMessage,
        metadata: {
          method: 'GET',
          status: response.status,
          error: data.error.message,
        },
      });
      handleAPIError(data);
    }

    const { user } = GetUserResponse.fromJson(data);

    if (!user) {
      const error = 'Failed to retrieve user';
      handleLog('error', {
        message: errorMessage,
        metadata: {
          error,
          user,
        },
      });
      throw new InternalError(error);
    }

    return { ...user };
  },
  createUser: async (user: Partial<User>): Promise<string> => {
    const response = await fetchWrapper(APIRoutes.users, {
      method: 'POST',
      body: JSON.stringify(new BufUser({ ...user })),
    });

    const data = await response.json();

    if (!response.ok) {
      handleLog('error', {
        message: 'UserService.createUser error',
        metadata: {
          method: 'POST',
          status: response.status,
          error: data.error,
        },
      });
      handleAPIError(data);
    }

    const { id } = CreateUserResponse.fromJson(data);

    return id;
  },
  updateUser: async (user: User): Promise<string> => {
    const response = await fetchWrapper(APIRoutes.users, {
      method: 'PUT',
      body: JSON.stringify(new BufUser({ ...user })),
    });

    const data = await response.json();

    if (!response.ok) {
      handleLog('error', {
        message: 'UserService.updateUser error',
        metadata: {
          method: 'PUT',
          status: response.status,
          error: data.error,
        },
      });
      handleAPIError(data);
    }

    const { id } = UpdateUserResponse.fromJson(data);

    return id;
  },
};
